module.exports = __webpack_public_path__ + "img/sun80.9471235e.jpg";